module.exports = __webpack_public_path__ + "img/rebel.93b61515.svg";